import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

const EditUserFormSchema = z.object({
  _id: z.string(),
  email: z.string(),
  address: z.string(),
  creditBalance: z.number(),
  firstName: z.string(),
  lastName: z.string(),
  isEmailVerified: z.boolean(),
  passwordChangeRequired: z.boolean(),
  phone: z.string(),
  primarilyDisability: z.string(),
  role: z.string(),
  twoFactorEnabled: z.boolean(),
});

export type EditUserForm = z.infer<typeof EditUserFormSchema>;

const editUserFormDefaultValues: EditUserForm = {
  _id: '',
  email: '',
  address: '',
  creditBalance: 0,
  firstName: '',
  lastName: '',
  isEmailVerified: false,
  passwordChangeRequired: false,
  phone: '',
  primarilyDisability: '',
  role: '',
  twoFactorEnabled: false,
};

export const useEditUserForm = () => {
  const form = useForm({
    defaultValues: editUserFormDefaultValues,
    resolver: zodResolver(EditUserFormSchema),
    reValidateMode: 'onBlur',
  });

  return form;
};
